/**
 * @generated SignedSource<<c9be9acb7b5d8f1bcaccf371375a3991>>
 * @relayHash 3ea9cc2571dfbc486c6703b148ec0077
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3ea9cc2571dfbc486c6703b148ec0077

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DrinkingHabit = "DAILY" | "FOUR_TO_FIVE_PER_WEEK" | "LESS_THAN_ONE_TIMES_PER_WEEK" | "NEVER" | "NOT_SPECIFIED" | "NO_LONGER" | "ONE_TO_THREE_PER_WEEK";
export type SmokingHabit = "IN_COMPANY" | "NEVER" | "NOT_SPECIFIED" | "NO_LONGER" | "REGULARLY";
export type De_updatePatientSocialHistoryInput = {
  comment?: string | null;
  drinkingHabit: DrinkingHabit;
  patientId: string;
  smokingHabit: SmokingHabit;
};
export type deUpdatePatientSocialHistoryMutation$variables = {
  input: De_updatePatientSocialHistoryInput;
};
export type deUpdatePatientSocialHistoryMutation$data = {
  readonly updatePatientSocialHistory: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly patientId?: string;
    }> | null;
    readonly socialHistory: {
      readonly " $fragmentSpreads": FragmentRefs<"SocialHistoryFragment">;
    } | null;
  };
};
export type deUpdatePatientSocialHistoryMutation = {
  response: deUpdatePatientSocialHistoryMutation$data;
  variables: deUpdatePatientSocialHistoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/)
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    (v2/*:: as any*/)
  ],
  "type": "PatientNotFound",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deUpdatePatientSocialHistoryMutation",
    "selections": [
      {
        "alias": "updatePatientSocialHistory",
        "args": (v1/*:: as any*/),
        "concreteType": "De_updatePatientSocialHistoryPayload",
        "kind": "LinkedField",
        "name": "de_updatePatientSocialHistory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SocialHistory",
            "kind": "LinkedField",
            "name": "socialHistory",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SocialHistoryFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deUpdatePatientSocialHistoryMutation",
    "selections": [
      {
        "alias": "updatePatientSocialHistory",
        "args": (v1/*:: as any*/),
        "concreteType": "De_updatePatientSocialHistoryPayload",
        "kind": "LinkedField",
        "name": "de_updatePatientSocialHistory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SocialHistory",
            "kind": "LinkedField",
            "name": "socialHistory",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "comment",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "drinkingHabit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "smokingHabit",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "3ea9cc2571dfbc486c6703b148ec0077",
    "metadata": {},
    "name": "deUpdatePatientSocialHistoryMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "960be357a829fe959464fca6b05412ef";

export default node;
